import assets from '../../apis/assets.api';
import { CurveOperation } from '../../types/curveManager.types';

export const bulkCurveOperation = (curveOps: CurveOperation[]) =>
	assets.post('/assets/bulk', curveOps);
